import * as THREE from "three";

export const TextureType = {
  COLOR: "color",
  DATA: "data",
};

function configureTexture(texture, type) {
  texture.wrapS = THREE.RepeatWrapping;

  texture.wrapT = THREE.RepeatWrapping;

  if (type === TextureType.COLOR) {
    texture.colorSpace = THREE.SRGBColorSpace;
  } else {
    texture.colorSpace = THREE.NoColorSpace;
  }

  texture.needsUpdate = true;

  return texture;
}

export function loadTextureFile(file, type = TextureType.DATA) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);

    const loader = new THREE.TextureLoader();

    loader.load(
      url,

      (texture) => {
        URL.revokeObjectURL(url);

        resolve(configureTexture(texture, type));
      },

      undefined,

      (error) => {
        URL.revokeObjectURL(url);

        reject(error);
      },
    );
  });
}
